module.exports = __webpack_public_path__ + "static/media/εἰμί_present_active_participle_img.9f3d943f.JPG";